export const FORM_PROPERTIES = {
	REQUIRED_ASTERIK: "*",
};
